import React from "react";
import FaqCategory from "./FaqCategory";

class Faqs extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        let groupItems =  _.groupBy(this.props.items,"MODFAQCategory");
        let faqWP =null;
        faqWP = Object.keys(groupItems).map((cat,catId) => (
                <FaqCategory cat={cat} data={groupItems[cat]} catId={catId} wpId={this.props.wpId} key={"FaqCategory_"+catId}/>
));
    return(
        <React.Fragment>
         {faqWP}
        </React.Fragment>
    );
}

}
export default Faqs;